import { render, staticRenderFns } from "./approveddeal.vue?vue&type=template&id=b31b3516&scoped=true&"
import script from "./approveddeal.vue?vue&type=script&lang=js&"
export * from "./approveddeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31b3516",
  null
  
)

export default component.exports